import type { ContentLoaderProps } from "@similarweb/ui-components";
import { ContentLoader } from "@similarweb/ui-components";

export const DashboardLoader = ({
    title,
    subtitle,
    className,
}: Omit<ContentLoaderProps, "children"> & { className?: string }) => (
    <div className={`dashboard-loader-container ${className || ""}`}>
        <ContentLoader
            title={title}
            subtitle={subtitle}
        >
            <div className="pdf-jumping" />
        </ContentLoader>
    </div>
);
